export default "__VITE_ASSET__ybrqmn6W__"